import { Grid, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import styles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { useNavigate, useSearchParams } from 'react-router-dom';
import whatsAppIcon from "../../../../../assets/Whatsapp.svg";
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import GlobalButton from '../../../../utility/globalButton/button';
import ChatbotWhatsAppIntegrationSetup from '../../../chatbot/chatbotWhatsAppIntegrationSetup';
import IconsColor from '../../../../utility/iconsColor';
import { MetaContext, MetaContextPayload } from '../../../../../context/metaContext';
import IntegrationDetails from './integrationDetails';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import agent from '../../../../../services/api';
import { checkForErrorCode, getWabaName, hasChannelsManageAccess, isAgentOrAdmin, isOrganizationRoleAgent } from '../../../../../utils/constants';
import { createMetaIntegrationPayloadNew, globalIntegration } from '../../../../../models/axiosModel';
import { GenericDataContext, GenericDataContextPayload } from '../../../../../context/genericDataContext';
import { accountSetupBreadcrumb, channelsBreadcrumb, homeBreadcrumb, phoneNumbersBreadcrumb } from '../../../../../utils/breadcrumb';
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { useIntegrationStore } from '../../../../../store/integrationStore';
import { findWhatsAppIntegration } from '../../../../../pages/ruleBasedInbox/utils';

interface checkFlag {
    flagPhone?: boolean
}

interface whatsAppData {
    waba_id: string,
    phone_number_id: string,
}

const AccountSetup = (props: checkFlag) => {
    const pathname = window.location.pathname.toLowerCase()
    const [searchParams] = useSearchParams()
    let id = searchParams.get('id')
    const { getChatbotIntegrationData, showIntegrationDetails, setShowIntegrationDetails, metaCredentials, GetMetaCredentials } = useContext(MetaContext) as MetaContextPayload;
    const { integrationDetails, globalIntegrationTypeList, setIntegrationDetails, getMetaIntegrationList, integrationListNewStructure, setIntegrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, userDetail, setUserDetail, handleError, onBoardUser, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const { breadcrumbs, setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload; 

    const { showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { setFlagOpenWabaVerificationForm, getWabaApprovalStatus, setFlagIntegrationNotAvailablePopup } = useIntegrationStore((useShallow((state) => ({
        setFlagOpenWabaVerificationForm: state.setFlagOpenWabaVerificationForm,
        getWabaApprovalStatus: state.getWabaApprovalStatus,
        setFlagIntegrationNotAvailablePopup: state.setFlagIntegrationNotAvailablePopup
    }))))

    const [responsePayload, setResponsePayload] = useState({
        response1: "",
        response2: ""
    })
    const [whatsappData, setWhatsappData] = useState<whatsAppData>({
        waba_id: "",
        phone_number_id: ""
    })

    useLayoutEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
            const res = await getMetaIntegrationList(id ? false : true)
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, [])

    useEffect(() => {
        if (searchParams.has('id')) {
            if (integrationListNewStructure && integrationListNewStructure.length > 0) {
                let id = searchParams.get('id')
                let integration = findWhatsAppIntegration(integrationListNewStructure, id ?? '');
                if (integration) {
                    setIntegrationDetails(integration)
                    setShowIntegrationDetails(true)
                } else {
                    // navigate('/channels')
                }
            }
        } else {
            setIntegrationDetails(null)
            setShowIntegrationDetails(false)
        }
    }, [integrationListNewStructure])

    useEffect(() => {
        if (id) {
            const updatedBreadcrumbs = [
                homeBreadcrumb,
                { ...channelsBreadcrumb },
                { name: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "Whatsapp"), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
                (props.flagPhone) ? { ...phoneNumbersBreadcrumb, isActive: true } : { ...accountSetupBreadcrumb, isActive: true },
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        } else {
            setBreadCrumbs([homeBreadcrumb, { ...channelsBreadcrumb }, { ...accountSetupBreadcrumb, isActive: true }]);
        }
    }, [id, integrationListNewStructure, pathname])

    useEffect(() => {
        if (userDetail.flagUser && !isOrganizationRoleAgent(userDetail) && !isAgentOrAdmin(userDetail) && userDetail?.user_organization_data?.organization_waba_approved) {
            if (!metaCredentials) {
                GetMetaCredentials();
            }
        }
    }, [metaCredentials, userDetail])

    const [codeValue, setCodeValue] = useState({
        code: ""
    })
    const injectFacebookSdkScript = () => {
        (function (d, s, id) {
            let js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s) as HTMLScriptElement;
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode!.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    // FB SDK is loaded async via script tag; when credentials arrive only after WABA approval,
    // launchWhatsAppSignup must wait for init instead of relying on the useEffect alone.
    const ensureFacebookSdkReady = (fbInit: any): Promise<void> => {
        return new Promise((resolve, reject) => {
            let settled = false;
            const finish = (error?: unknown) => {
                if (settled) return;
                settled = true;
                if (error) reject(error);
                else resolve();
            };

            const initSdk = () => {
                try {
                    // @ts-ignore
                    FB.init(fbInit);
                    finish();
                } catch (error) {
                    finish(error);
                }
            };

            if (window.FB) {
                initSdk();
                return;
            }

            window.fbAsyncInit = function () {
                initSdk();
            };

            injectFacebookSdkScript();

            const start = Date.now();
            const poll = window.setInterval(() => {
                if (settled) {
                    window.clearInterval(poll);
                    return;
                }
                if (window.FB) {
                    window.clearInterval(poll);
                    initSdk();
                } else if (Date.now() - start > 10000) {
                    window.clearInterval(poll);
                    finish(new Error("Facebook SDK not loaded"));
                }
            }, 100);
        });
    };

    useEffect(() => {
        if (metaCredentials) {
            let facebookConfig = metaCredentials.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")
            window.fbAsyncInit = function () {
                // @ts-ignore
                FB.init(facebookConfig?.fb_init);
            };
            injectFacebookSdkScript();
        }
    }, [metaCredentials]);
    const navigate = useNavigate()
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const tabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)')
    const laptopScreen = useMediaQuery('(max-width : 1600px) and (min-width : 900px)')

    const getWabaApprovalStatusApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getWabaApprovalStatus(String(userDetail?.user_organization_data?.organization_id ?? ''));
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        return res;
    }

    const launchWhatsAppSignup = async () => {
        let metaCredentialsData = metaCredentials;
        if(!userDetail?.user_organization_data?.organization_waba_approved){
            const wabaApprovalStatus = await getWabaApprovalStatusApi();
            const status = wabaApprovalStatus?.data?.organization_waba_integration_status?.toLowerCase();
            if(status !== 'approved'){
                setFlagOpenWabaVerificationForm(true);
                return;
            } else {
                let whatsappConfig = metaCredentialsData?.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")
                if(!whatsappConfig){
                    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
                    metaCredentialsData = (await GetMetaCredentials())?.data ?? null;
                    setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
                }
            }
        }
        let whatsappConfiguration = metaCredentialsData?.find((configuration) => configuration.channel_name.toLowerCase() == "whatsapp")

        if (!whatsappConfiguration?.fb_init) {
            showError("WhatsApp configuration not available. Please try again.");
            return;
        }

        if(!whatsappConfiguration?.flag_can_integrate){
            setFlagIntegrationNotAvailablePopup(true);
            return;
        }

        try {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            await ensureFacebookSdkReady(whatsappConfiguration.fb_init);
        } catch (error) {
            console.error("Facebook SDK not loaded", error);
            showError("Facebook SDK failed to load. Please refresh and try again.");
            return;
        } finally {
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }

        // @ts-ignore
        window.FB.login(function (response: any) {
            if (response.authResponse) {
                console.log("authresponse in whatsapp----", response)
                const accessToken = response.authResponse.accessToken;
                if (response.authResponse.code) {
                    setCodeValue({ ...codeValue, code: response.authResponse.code })
                    setResponsePayload((prevState) => ({ ...prevState, response1: response }))
                }
                // Further actions after successful login
            } else {
                showError("User cancelled login or did not fully authorize.")
            }
        },
            whatsappConfiguration?.signup_config
            // {
            //     config_id: '770031065005404',
            //     response_type: 'code',
            //     override_default_response_type: true,
            //     extras: {
            //         "sessionInfoVersion": 2
            //     }
            // }
        );
    };
    useEffect(() => {
        const sessionInfoListener = (event: MessageEvent) => {
            if (event.origin !== "https://www.facebook.com") return;
            try {
                const data = JSON.parse(event.data);
                // Handle the data from the event
                // console.log("session info data", data);


                if (data.type === 'WA_EMBEDDED_SIGNUP') {
                    // if user finishes the Embedded Signup flow
                    if (data.event === 'FINISH' || data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') {
                        const { phone_number_id, waba_id } = data.data;
                        setWhatsappData({ ...whatsappData, phone_number_id: phone_number_id, waba_id: waba_id })
                        setResponsePayload((prevState) => ({ ...prevState, response2: data }))
                    }
                    // if user cancels the Embedded Signup flow
                    else {
                        const { current_step } = data.data;
                    }
                }
            } catch (error) {
                // Handle errors or non-JSON messages
            }
        };
        window.addEventListener('message', sessionInfoListener);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('message', sessionInfoListener);
        };
    }, []);

    // useEffect(() => {
    //     if (integrationDetails !== null) {
    //         setShowIntegrationDetails(true)
    //     } else {
    //         setShowIntegrationDetails(false)
    //     }
    // }, [getChatbotIntegrationData])

    const safeLogout = (): void => {
        // Check the user's current login status
        window.FB.getLoginStatus((response: any) => {
            if (response.status === 'connected') {
                // User is logged in to your app and Facebook.
                // It's safe to call logout
                window.FB.logout((logoutResponse: any) => {
                    console.log('User logged out successfully', logoutResponse);
                    // Handle post-logout logic here
                });
            } else {
                console.log('User was not logged in via Facebook SDK. No need to log out.');
                // Handle scenarios where the user was not logged in
            }
        });
    };

    useEffect(() => {
        (async () => {
            let chatbot_id = searchParams.get('chatbot_id') ?? ""
            if (codeValue.code !== "" && whatsappData.waba_id !== "" && whatsappData.phone_number_id !== "" && Number(chatbot_id) !== -1 && getChatbotIntegrationData == null) {
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
                let whatsappObj = {
                    waba_id: whatsappData.waba_id,
                    phone_number_id: whatsappData.phone_number_id,
                    code: codeValue.code
                }
                let payload: createMetaIntegrationPayloadNew = {
                    channel_id: globalIntegrationTypeList.find((integrationType) => integrationType.channel_name.toLowerCase() == "whatsapp")?.channel_id ?? Number(process.env.REACT_APP_WHATSAPP_META_INTEGRATION_TYPE_ID),
                    meta_integration_whatsapp_data: whatsappObj,
                    channel_authoriser_user_data: {
                        authoriser_unique_id: 0,
                        authoriser_unique_name: "",
                        authoriser_unique_email: "",
                    },
                    meta_data: JSON.stringify(responsePayload)
                }

                const response = await agent.createMetaIntegration.post(payload);
                if (response.status) {
                    onBoardUser(); // On Board User to the platform.
                    showSuccess("Integration Successfull!")
                    let responseNewStructure = response.data[0]
                    let whatsappIntegrations = responseNewStructure.meta_integration_whatsapp_data.map((integration: any) => {
                        return {
                            ...integration,
                            integrated_channel_id: integration.meta_integration_whatsapp_id,
                            channel_name: 'Whatsapp'
                        }
                    })
                    setIntegrationListNewStructure([...whatsappIntegrations, ...responseNewStructure.meta_integration_facebook_data, ...responseNewStructure.meta_integration_instagram_data])
                    let sortedData = whatsappIntegrations.sort((a: globalIntegration, b: globalIntegration) => new Date(b.created_at_timestamp).getTime() - new Date(a.created_at_timestamp).getTime())
                    let data = sortedData[0]
                    navigate(`/channels/viewintegration/whatsapp?id=${data.integrated_channel_id}`)
                    setIntegrationDetails(response)


                    // const response = await GetChatbotIntegrationData(chatbotId, "")
                    // if (response.status) {
                    //     if (response.data && response.data.length > 0) {
                    //         setShowIntegrationDetails(true)
                    //     }
                    // }
                } else {
                    let errorCode = checkForErrorCode(response)
                    if (response.message == "canceled") {
                    }
                    else {
                        handleError(response);
                    }
                    setCodeValue({ code: "" });
                    setWhatsappData({ waba_id: "", phone_number_id: "" });
                    setResponsePayload({
                        response1: "",
                        response2: ""
                    })
                    safeLogout();
                }
                setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))

            }
        })()
    }, [codeValue, whatsappData])

    const innerHeight = smallScreen ? (window.innerHeight - 90) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 100) : (window.innerHeight - 110);
    const innerPhoneHeight = smallScreen ? (window.innerHeight - 110) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 120) : (window.innerHeight - 140);
    const integrationViewInnerHeight = smallScreen ? (window.innerHeight - 110) : tabletScreen ? (window.innerHeight - 100) : laptopScreen ? (window.innerHeight - 120) : (window.innerHeight - 140);

    return (
        <Grid item
            className={showIntegrationDetails == false ? `${globalStyles.fullwidth} ${styles.integrationDefaultView}` : pathname.includes('phonenumbers') ? `${globalStyles.fullwidth} ${styles.integrationPhoneView}` : `${globalStyles.fullwidth} ${styles.integrationView}`}
            height={showIntegrationDetails == false ? `${innerHeight}px !important` : pathname.includes('phonenumbers') ? `${innerPhoneHeight}px !important` : `${integrationViewInnerHeight}px !important`}
        >
            <Grid container>
                {showIntegrationDetails == false &&
                    <Grid item className={globalStyles.fullwidth}>
                        <Grid container className={`${globalStyles.trySampleChatbotContainer} ${globalStyles.containerFlexWrap}`} gap={"13px"} flexDirection={{ xs: "row-reverse", md: "row" }}>
                            <Grid item className={styles.integrationContent}>
                                <img alt="" src={whatsAppIcon} className={styles.whatsappIntegrationIcon} />
                            </Grid>
                            <Grid item>
                                <Grid container className={globalStyles.flexColumn} gap={{ xs: "8px", md: "4px" }}>
                                    <Grid item>
                                        <Typography className={globalStyles.whatsappIntegrationFontStyle}>WhatsApp Integration</Typography>
                                    </Grid>
                                    <Grid item>
                                        <span className={globalStyles.whatsappIntegrationSubFontStyle}>Integrate AI Chatbot into your WhatsApp Business account to boost customer engagement and efficiency.</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }

                {(showIntegrationDetails) ?
                    <>
                        <Grid item className={globalStyles.fullwidth} xs={12} lg={12} xl={12}>
                            <Grid container gap={3} >
                                <IntegrationDetails flagPhone={props.flagPhone} />
                            </Grid>
                        </Grid>
                    </>
                    :
                    <>
                        {/* {showIntegrationDetails == false && */}
                            {integrationListNewStructure && 
                                <Grid item className={globalStyles.fullwidth} xs={12} lg={8} xl={6} mt={4}>
                                    <Grid container pt={1} className={`${styles.integrationWorking} ${globalStyles.flexColumn} ${globalStyles.gapTwo} ${globalStyles.containerFlexWrap}`}>
                                        <Grid item>
                                            <Grid container className={`${globalStyles.containerflexWrapStyle} ${globalStyles.spaceAlignmentCenter} ${globalStyles.gapOne}`} >
                                                <Grid item>
                                                    <span className={globalStyles.whatsappIntegrationFontStyle}>Prerequisites for WhatsApp Integration</span>
                                                </Grid>
                                                <Grid item className={styles.workingIconStyle}>
                                                    <IconsColor iconName="ideaIcon" height={"30"} width={"30"} />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <ChatbotWhatsAppIntegrationSetup launch={launchWhatsAppSignup} viewIntegration={true} />
                                    </Grid>
                                    <Grid container>
                                        <Grid item className={`${styles.integrateGridStyles} ${styles.blockMargin}`}>
                                            <Grid container>
                                                <Grid item xs={12} >
                                                    <GlobalButton
                                                        buttonText={"Integrate Now"}
                                                        className="primaryButtonStyle"
                                                        onClick={() => { launchWhatsAppSignup() }}
                                                        disabled={!hasChannelsManageAccess(apiRoutesPermissionAssignment, userDetail)}
                                                        sx={{ padding: "6px 20px !important" }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            }
                        {/* } */}
                    </>
                }
            </Grid>
        </Grid>
    )
}

export default AccountSetup
